// Schools tab: target schools (with derived Visit column), grouped visits, offers.
import React, { useState } from 'react';
import TargetSchoolsEditor from '../TargetSchoolsEditor';
import ConciergeVisitsEditor from '../../ConciergeVisitsEditor';
import OffersCard from './OffersCard';

export default function SchoolsTab({ userId, onSaved, profile }) {
  const [visits, setVisits] = useState([]);
  const [targets, setTargets] = useState([]);
  return (
    <div className="cn-tabbody">
      <TargetSchoolsEditor userId={userId} onSaved={onSaved} visits={visits} onSchoolsChange={setTargets} />
      <ConciergeVisitsEditor userId={userId} onSaved={onSaved} onVisitsChange={setVisits}
        targetUnitids={targets.map(t => t.unitid).filter(u => u != null)} />
      <OffersCard userId={userId} onSaved={onSaved} athleteSport={profile?.sport || null} />
    </div>
  );
}
